import React from "react";
import IColumn from "../../../yoello-lib/modules/components/lists/interfaces/IColumn";
import { IProcessedOrders } from "../constants";
import Styles from "../../../scss/orderHistory.module.scss";
import {ReactComponent as TickSquare} from "../../../assets/images/tick-square-blue.svg"

interface IOrderListItemProps {
    onClickItem?: (order: IProcessedOrders) => void;
    columns: IColumn<string>[];
    order: IProcessedOrders;
    className?: string;
    props?: any;
    showCheckBox?:boolean;
}

export function OrderListItem({
    onClickItem,
    columns,
    order,
    className = Styles.historyItems,
    props,
    showCheckBox
}: IOrderListItemProps) {
    function onClick() {
        if (onClickItem) {
            onClickItem(order);
        }
    }

    return <div className={className || Styles.historyItems} onClick={onClick}>
        <div key={order.id} data-component-name="OrderHistoryCard">
            {
                columns.map((column) => {
                    return column.componentTransform ?
                        column.componentTransform(order[column.key], order.id, props) :
                        <span key={`${order.id}-${column.key}`}>{order[column.key]}</span>;
                })
                
            }
        </div>
        {showCheckBox && <span className={Styles.TickSquare}> <TickSquare/> </span>}
    </div>;

}